<template>
  <div>
    <div class="form-group col-xs-12 col-sm-6">
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <label for="country">Country</label>
          <nv-select
            id="country"
            v-model="selectedCountry"
            v-on:change="getLanguagesInCountry()"
            class="form-control"
          >
            <option value>--Choose Country--</option>
            <option v-for="(value, key) in countryAndLanguages" :key="key" :value="key">{{key}}</option>
          </nv-select>
        </div>
        <div class="col-xs-12 col-sm-6">
          <label for="languages">Languages</label>
          <nv-select class="form-control" v-model="messageLanguage" id="languages">
            <option value>--Choose language--</option>
            <option
              v-for="(value, index) in languages"
              :key="index"
              :value="value.alias"
            >{{value.name}}</option>
          </nv-select>
        </div>
      </div>
    </div>
    <div class="form-group col-xs-12 col-sm-6">
      <label>Message</label>
      <div class="two-fields">
        <textarea v-model="messageText" rows="4" class="form-control" placeholder="message"/>
        <i class="fa fa-plus-circle add-property" @click="addTranslation" aria-hidden="true"></i>
      </div>
    </div>
    <table v-if="Object.keys(messages).length" class="table table-striped">
      <thead>
        <th>Language</th>
        <th>Text</th>
        <th>Delete</th>
      </thead>
      <tbody>
        <tr v-for="(value, key) in messages" :key="key">
          <td>{{key}}</td>
          <td>{{value}}</td>
          <td>
            <i class="fa fa-times-circle" v-on:click="removeMessage(key)" aria-hidden="true"></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'nudge-message',
  data () {
    return {
      selectedCountry: '',
      messageLanguage: '',
      messageText: '',
      languages: []
    }
  },
  computed: mapState({
    countryAndLanguages: state => state.general.countryAndLanguages,
    messages: state => state.nudge.messages
  }),
  methods: {
    addTranslation () {
      if (this.messageLanguage && this.messageText) {
        this.addMessage({
          language: this.messageLanguage,
          text: this.messageText
        })
        this.messageLanguage = ''
        this.messageText = ''
        this.selectedCountry = ''
      } else {
        this.$swal({
          type: 'error',
          text: 'You must select a language & enter a text'
        })
      }
    },
    getLanguagesInCountry () {
      if (!this.selectedCountry) {
        this.languages = []
      } else {
        this.languages = this.countryAndLanguages[this.selectedCountry]
      }
    },
    ...mapActions([
      'getLanguages',
      'addMessage',
      'removeMessage'
    ])
  },
  mounted () {
    this.getLanguages()
  }
}
</script>




// WEBPACK FOOTER //
// messages.vue?0f0109b3